module.exports = __webpack_public_path__ + "assets/img/00131.ed708aa9.png";